import React from 'react';
import styles from './ShareButtons.css';
import HatenaShareButton from './HatenaShareButton.jsx'
import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    LineShareButton,
    LineIcon,
    EmailShareButton,
    EmailIcon,
} from 'react-share';



const ShareButtons = ({ shareTitle, shareUrl }) => (
    <div className={styles['sharebuttons']}>
        <TwitterShareButton className="sharebuttons" title={shareTitle + "\n"} via="kiotera_tech" url={shareUrl}>
            <TwitterIcon size={32} round />
        </TwitterShareButton>
        <FacebookShareButton className="sharebuttons" url={shareUrl} quote={shareTitle}>
            <FacebookIcon size={32} round />
        </FacebookShareButton>
        <LineShareButton className="sharebuttons" url={shareUrl} quote={shareTitle}>
            <LineIcon size={32} round />
        </LineShareButton>
        <EmailShareButton className="sharebuttons" subject={shareTitle} body={shareUrl}>
            <EmailIcon size={32} round />
        </EmailShareButton>
        <a
          href="https://b.hatena.ne.jp/entry/"
          className="hatena-bookmark-button"
          data-hatena-bookmark-layout="basic"
          title="このエントリーをはてなブックマークに追加"
        >
          <img
            src="https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png"
            className="hatebuImage"
            alt="このエントリーをはてなブックマークに追加"
            width="32"
            height="32"
          />
        </a>
        <script
          type="text/javascript"
          src="https://b.st-hatena.com/js/bookmark_button.js"
          charset="utf-8"
          async="async"
        ></script>
    </div>
);
export default ShareButtons;